module.exports = __webpack_public_path__ + "media/images/greeting-5ad520ba4928840a6ede9852a09c0359.svg";